import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Image from 'components/Image';
import {
  getURLwithTag,
  getKeyword,
  getOnClickWindowFuntion,
} from 'routes/articleshow_v2/utils/mspUtils';
import AffiliatesContent from 'components/AffiliatesContent/AffiliatesContent';
import AffiliatesContentV2 from '../../../components/AffiliatesContentV2/AffiliatesContentV2';
import Links from '../../../components/Link/Link';
import s from './style.scss';

const AffiliateProductPanel = props => {
  const {
    componentProps = {},
    isMobile,
    handleOrganic,
    isPaidTraffic,
    isMspUSPage,
    keyword,
    data: {
      id,
      affiliateName,
      sectionl1,
      description = [],
      fallbackImageURL,
      hasMultipleProductIds,
      hasMixedContent,
      productListMsid,
      imgid,
      isV2,
      isHotPicks,
    },
  } = props;
  const [fallback, setFallback] = useState(false);
  const onClickWindowFunction =
    sectionl1 && !isHotPicks
      ? getOnClickWindowFuntion('dfpPush', [
          'ua:click',
          `${affiliateName || 'amazon'}-affiliate-${sectionl1}`,
        ])
      : null;

  const getType = () => {
    let type;
    if (productListMsid) {
      type = 'msp_multi_product_inline_image';
    } else if (hasMixedContent) {
      type = 'product_widget_mixed';
    } else if (hasMultipleProductIds) {
      type = 'multi_product_widget';
    } else {
      type = 'product_widget';
    }
    return `${type}${isMspUSPage ? '_us' : ''}`;
  };

  const getConditionalFilters = () => {
    const filterObj = {};
    if (productListMsid) {
      filterObj.productlistmsid = productListMsid;
    } else filterObj.productID = id;
    return filterObj;
  };

  const classNames = cn({
    [s.aff_product_panel_card]: !hasMultipleProductIds && !productListMsid,
    // [s.web]: !(isMobile || isHotPicks),
    // [s.disabledlink]: hasMultipleProductIds || productListMsid,
  });

  componentProps.config = componentProps.config || {};
  componentProps.config.windowFunctions = [onClickWindowFunction];

  const getAffilateContent = () =>
    isV2 ? (
      <AffiliatesContentV2
        inViewClass={classNames}
        type="msp_product_widget"
        client="affiliates"
        showWidgetOnPrimeToo
        handlePaidTraffic
        filters={{
          pagename: isHotPicks ? 'hot-picks' : 'articleshow',
          sectionl1,
          keyword: getKeyword(keyword),
          affiliateName,
          imgid,
          productid: id,
          affiliateCountry: isMspUSPage ? 'us' : '',
        }}
        componentProps={componentProps}
        noShowCallback={() => {
          setFallback(true);
        }}
        onContentLoaded={(response = {}) => {
          const { data = {} } = response;
          const { items = [] } = data;
          const url = items[0] ? items[0].url : data.url || '';
          if (!url) {
            setFallback(true);
          }
        }}
        handleOrganic={handleOrganic}
      />
    ) : (
      <AffiliatesContent
        enableWidgetsOnLoad
        inViewClass={classNames}
        type={getType()}
        handlePaidTraffic
        filters={{
          pagename: 'articleshow',
          affiliateName: hasMixedContent ? '' : affiliateName,
          sectionl1,
          imgid,
          keyword: getKeyword(keyword),
          addaffiliates: 'yes',
          affiliateCountry: isMspUSPage ? 'us' : '',
          ...getConditionalFilters(),
        }}
        componentProps={componentProps}
        noShowCallback={() => {
          setFallback(true);
        }}
        onContentLoaded={() => {}}
        handleOrganic={handleOrganic}
      />
    );

  return (
    <>
      <div data-msp_product_id={id} className={s.aff_product_panel_title}>
        {/* {getHeading()} */}
      </div>
      {fallback && !hasMultipleProductIds ? (
        <Image
          src={fallbackImageURL}
          className={`${s.aff_product_panel_card} ${!isMobile ? s.web : ''} ${
            s.is_image
          }`}
        />
      ) : (
        getAffilateContent()
      )}
      {description.map(desc => {
        if (fallback && hasMultipleProductIds) {
          return '';
        }
        const { wu, value, tag } = desc;
        if (desc.tn === 'link') {
          // eslint-disable-next-line no-nested-ternary
          return hasMultipleProductIds || productListMsid ? (
            value
          ) : (
            <Links
              rel="nofollow"
              to={getURLwithTag(wu, tag, '', isPaidTraffic)}
              isMspArticle
              target="_blank"
              forceTargetBlank
            >
              {value}
            </Links>
          );
        }
        return <span>{desc.value}</span>;
      })}
    </>
  );
};

AffiliateProductPanel.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    affiliateName: PropTypes.string,
    title: PropTypes.string,
    sectionl1: PropTypes.string,
    fallbackImageURL: PropTypes.string,
    productListMsid: PropTypes.string,
    description: PropTypes.shape([]),
    hasMultipleProductIds: PropTypes.bool,
    hasMixedContent: PropTypes.bool,
    isV2: PropTypes.bool,
    imgid: PropTypes.string,
    index: PropTypes.string,
    isHotPicks: PropTypes.bool,
  }),
  componentProps: PropTypes.shape({}),
  dataGA: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  handleOrganic: PropTypes.bool,
  isPaidTraffic: PropTypes.bool,
  isMspUSPage: PropTypes.bool,
  keyword: PropTypes.string,
};

AffiliateProductPanel.defaultProps = {
  data: {
    imgid: '',
    isV2: false,
    hasMixedContent: false,
    isHotPicks: false,
  },
  componentProps: {},
  dataGA: {},
  isMobile: false,
  handleOrganic: false,
  isMspUSPage: false,
  isPaidTraffic: false,
  keyword: '',
};

export default AffiliateProductPanel;
